import React, { createContext, useContext } from 'react'
import type { Company, Site } from '@/features/companies/api/companies.data.ts'

export interface CompanyState extends Company {
  sites: Array<Site>
  // Helper methods for route guards
  hasSite: (siteId: string) => boolean
}

const CompanyContext = createContext<CompanyState | undefined>(undefined)

export function CompanyProvider({
  children,
  company
}: {
  children: React.ReactNode
  company: CompanyState
}) {
  return <CompanyContext.Provider value={company}>{children}</CompanyContext.Provider>
}

// eslint-disable-next-line react-refresh/only-export-components
export function useCompany() {
  const context = useContext(CompanyContext)
  if (context === undefined) {
    throw new Error('useCompany must be used within an CompanyProvider')
  }
  return context
}
